import { initializeApp } from "firebase/app";
import {
	GoogleAuthProvider,
	FacebookAuthProvider,
	initializeAuth,
	signInWithPopup,
	browserLocalPersistence,
	browserPopupRedirectResolver,
} from "firebase/auth";

function init() {
	const firebaseConfig = {
		apiKey: "AIzaSyCdQby8YuciXlrawEYf4rh9bMA2AhI-eCs",
		authDomain: "nyansa-163ef.firebaseapp.com",
		projectId: "nyansa-163ef",
		storageBucket: "nyansa-163ef.firebasestorage.app",
		appId: "nyansa-163ef",
	};

	const app = initializeApp(firebaseConfig);

	const auth = initializeAuth(app, {
		persistence: [browserLocalPersistence],
		popupRedirectResolver: browserPopupRedirectResolver,
	});
	return auth;
}

async function saveUser(idToken: string) {
	try {
		const response = await fetch("/login/firebase", {
			method: "POST",
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
				Authorization: `Bearer ${idToken}`,
			},
			body: new URLSearchParams({
				token: idToken,
				_csrf: (document.getElementsByName("_csrf")[0] as HTMLInputElement)
					.value,
			}).toString(),
		});

		if (!response.ok) {
			throw new Error(`Server error: ${response.status}`);
		}

		window.location.reload();
	} catch (error) {
		console.error("Error sending user data to backend:", error);
	}
}

/**
 * Initiate social signin process
 *
 * @param   {String}  providerId  facebook | google
 */
async function signIn(providerId: "facebook" | "google") {
	const provider =
		providerId === "facebook" ? FacebookAuthProvider : GoogleAuthProvider;

	const auth = init();

	signInWithPopup(auth, new provider())
		.then(async (result) => {
			// @ts-ignore
			await saveUser(result._tokenResponse.idToken);
		})
		.catch((error) => {
			console.error("Login error", error);
		});
}

document.addEventListener("DOMContentLoaded", async () => {
	document
		?.getElementById("google-signin-btn")
		?.addEventListener("click", (_e) => {
			signIn("google");
		});

	document
		?.getElementById("facebook-signin-btn")
		?.addEventListener("click", (_e) => {
			signIn("facebook");
		});
});

// TODO: implement logout
